import axios from "axios";
import { BASE_URL_STRING } from "./axios";

export const BASE_URL = BASE_URL_STRING;
export const EndPoints = {
  getLessonById: "/dashboard/details/{lessonId}",
  searchLessons: "/dashboard/search",
  toggleLessonStatus: "/toggle-status",
  editLesson: "/edit",
  getEducationStages: "/education-stages/list",
  deleteVideo: "/delete-video",
  uploadVideo: "/upload-video",
  addLesson: "/add",
  getLessons: "/dashboard/list",

};

export const createLessonsAPIEndpoint = (endpoint) => {
  let url = BASE_URL + "v1/lessons" + endpoint + "/";
  const token = sessionStorage.getItem("token");
  return {
    fetch: (options) =>
      axios.get(url, {
        ...options,
        headers: { Authorization: `Bearer ${token}` },
      }),

    post: (newRecord) => axios.post(url, newRecord),
    postWithToken: (newRecord) =>
      axios.post(url, newRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    postById: (id, newRecord) =>
      axios.post(url + id, newRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    put: (updatedRecord) =>
      axios.put(url, updatedRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    putById: (id, updatedRecord) =>
      axios.put(url + id, updatedRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    delete: (id) =>
      axios.delete(url + id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
  };
};

